import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const rows = [{
  before: '😩 Semanas muertas esperando un cliente que no regatee',
  after: '✅ −90% tiempo muerto. Fabrica hoy, vende mañana.'
}, {
  before: '🔄 Miedo a que 50€ sea "caro" por una pieza',
  after: '✅ Confianza total. Vendes diseño y utilidad.'
}, {
  before: '📉 Retales en la basura. Dinero tirado.',
  after: '✅ Tus sobras son tu materia prima gratuita. Cada recorte es una pieza de 45€-80€ de beneficio neto.'
}, {
  before: '💼 "Soy el apañao de los recados"',
  after: '✅ "Tengo mi marca de artesanía online."'
}];
export function Transformation() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-219" data-mp="21o7d7m71h2dc">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-220" data-mp="2z4o2jp3s31c2">
        <SectionTag icon="⚡" data-id="element-221" data-mp="2z5z6box84936">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-222" data-mp="2udo3oeb3m96x">
          Tu taller no debería ser un almacén de madera muerta.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-223" data-mp="1a6zqlpw83can">
          Mirar ese montón de recortes que te costaron una fortuna y no saber qué hacer con ellos es ver
          dinero perdiéndose cada día. El miedo a fabricar algo "grande" y que nadie lo compre te tiene
          paralizado.
        </p>

        <div className="mt-6 rounded-2xl border border-brown/25 bg-brown/5 p-5 text-left sm:p-6" data-id="element-224" data-mp="mgnctyeaqlc5">
          <p className="font-heading text-sm font-bold uppercase tracking-wide text-brown" data-id="element-225" data-mp="rht6byfs6cmq">
            Recupera la rentabilidad de tu ingenio
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-226" data-mp="djcxo1ycyc1y">
            <span className="font-semibold text-ink" data-id="element-227" data-mp="hkohtrygq52r">El coste real:</span> Intentar vender muebles grandes o
            esperar a que te salga una "chapuza" de reforma te quita tiempo y salud. Es hora de fabricar
            objetos que la gente desea regalar.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-228" data-mp="3krgvk35hzrbd">
        <p className="mb-4 text-center font-heading text-sm font-bold uppercase tracking-wide text-muted" data-id="element-229" data-mp="3ftfchi82nrzw">
          Las 4 Transformaciones
        </p>
        <ScrollHintTable minWidth="600px" data-id="element-230" data-mp="3buq27yibyqkh">
          <table className="w-full text-left text-sm" data-id="element-231" data-mp="36utym0djp15g">
            <thead data-id="element-232" data-mp="36w52e06zq8wk">
              <tr className="border-b border-brown/15 bg-brown/5 text-xs uppercase tracking-wide text-muted" data-id="element-233" data-mp="7ef4a8scle33">
                <th className="px-5 py-3 font-semibold" data-id="element-234" data-mp="3ctly7x1o7li">Antes</th>
                <th className="px-5 py-3 font-semibold" data-id="element-235" data-mp="3ffw8fbbl17f">Ahora</th>
              </tr>
            </thead>
            <tbody data-id="element-236" data-mp="3pso4i5jdmwjm">
              {rows.map((row, i) => <m.tr key={row.before} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.08
            }} className={i !== rows.length - 1 ? 'border-b border-brown/10' : ''} data-id="element-237" data-mp="3prlgc5dfv87e" data-mpi={i}>
                  <td className="px-5 py-4 align-top leading-relaxed text-muted" data-id="element-238" data-mp="yn8bkhfel0le">{row.before}</td>
                  <td className="px-5 py-4 align-top leading-relaxed text-ink" data-id="element-239" data-mp="13k72ys7omtfw">{row.after}</td>
                </m.tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <div className="mt-8 rounded-2xl border border-brown/25 bg-white p-6 shadow-card sm:p-7" data-id="element-240" data-mp="1cmgcpfv4mis8">
          <p className="text-center font-heading text-lg font-bold text-ink sm:text-xl" data-id="element-241" data-mp="1hkhuzykqae2n">
            ¿Cuánto dinero tienes tirado en el suelo?
          </p>
          <div className="mt-5 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-6" data-id="element-242" data-mp="1mdujm8peqkve">
            <div className="flex flex-col items-center gap-1 rounded-xl border border-brown/15 bg-bg-secondary px-6 py-4 text-center" data-id="element-243" data-mp="1rcxc6to7aymh">
              <span className="text-xs uppercase tracking-wide text-muted" data-id="element-244" data-mp="20azldwi38xku">Retal de roble (30cm)</span>
              <span className="font-heading text-2xl font-bold text-danger line-through" data-id="element-245" data-mp="1moa9s5jjwhs6">0€</span>
              <span className="text-xs text-muted" data-id="element-246" data-mp="1inqgxe60g0bu">Basura</span>
            </div>
            <span className="text-2xl text-brown/50" aria-hidden="true" data-id="element-247" data-mp="1welpsqgiehff">
              →
            </span>
            <div className="flex flex-col items-center gap-1 rounded-xl border border-success/25 bg-success/5 px-6 py-4 text-center" data-id="element-248" data-mp="1rfse93ks90hw">
              <span className="text-xs uppercase tracking-wide text-muted" data-id="element-249" data-mp="13qpm31sivp95">
                Convertido en soporte de laptop
              </span>
              <span className="font-heading text-2xl font-bold text-success" data-id="element-250" data-mp="zqp8tkh5tk3o">45€</span>
              <span className="text-xs text-muted" data-id="element-251" data-mp="1dm135qrel8k2">Venta real</span>
            </div>
          </div>
          <p className="mt-5 text-center font-heading text-sm font-bold uppercase tracking-wide text-brown" data-id="element-252" data-mp="18r3wgqhljbac">
            El Kit se paga solo con tu primera venta de sobras.
          </p>
        </div>
      </div>
    </section>;
}